define.alias("shared/components/shared/ui/social-set-switcher", "calendar/components/shared/ui/social-set-switcher");